import React from "react";
import InputMask from "react-input-mask";
import classnames from "class-names";

const PhoneInput = ({ id, className, name, value, required, disabled }) => (
  <InputMask
    name={name}
    id={name.replace('[', '_').replace(']', '')}
    mask="+7 (999) 999 99 99"
    defaultValue={value}
    className={classnames("input-group__input", "js-phone-input", className)}
    id={id}
    required={required}
    disabled={disabled}
  />
);

export default PhoneInput;
